<template>
  <div>
    <v-dialog v-model="isOpen" persistent max-width="600px" scrollable>
      <v-card>
        <v-card-title class="headline gradiente lighten-2 elevation-3">
          <span class="white--text">Descargar reporte</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout align-center justify-center wrap row>
              <v-flex xs12>
                <h3>
                Elige el rango de fecha para descargar el reporte.
                </h3>
              </v-flex>
            </v-layout>
            <v-layout align-center justify-center wrap row>
              <v-flex xs12 sm6 mt-4>
                <v-menu
                  v-model="from"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDate"
                      label="Fecha de inicio"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    header-color="primary"
                    color="secondary"
                    locale="es-419"
                    v-model="startDate"
                    :max="today"
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6 mt-4>
                <v-menu
                  v-model="to"
                  :close-on-content-click="true"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDate"
                      label="Fecha de término"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    header-color="primary"
                    color="secondary"
                    locale="es-419"
                    v-model="endDate"
                    :max="today"
                    :min="startDate"
                    scrollable
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :disabled="downloading" flat @click="close">Cancelar</v-btn>
          <v-btn :disabled="downloading" flat @click="getReport" color="primary darken-1">Descargar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: ['isOpen'],
  data: () => ({
    from: false,
    to: false,
    downloading: false,
    startDate: '',
    endDate: '',
    today: moment().format('YYYY-MM-DD'),
  }),
  methods: {
    close() {
      this.$emit('onClose', false)
    },
    onOpen() {
      this.startDate = this.today;
      this.endDate = this.today;
      this.downloading=false;
    },
    onClose() {
      console.log("dowloadXlsModal onClose")
      this.downloading=false;
    },
    getReport() {
      console.log("Emmiting onGetReport")
      this.downloading=true;
      this.$emit("onGetReport", { startDate: this.startDate , endDate: this.endDate});
    }
  },
  mounted() {
    console.log('mounted', this.props)
    this.startDate = this.today;
    this.endDate = this.today;
  },
}
</script>

<style></style>
